module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch02",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "partno",
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 13. ",
      "epub:type": "pagebreak",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', [_vm._v("GATHER DAYS AT THREE FORKS")])])])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img00",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec01",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec01"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 15. ",
      "epub:type": "pagebreak",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of Moon turning to ash")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are camped by Three Rivers Come Together—out on the wide grasses far from Agai. I am nine winters aged. In my gut, Land tells me we are not wanted in this place of Earth mounds and distant Mountains, growl-thick with Moose stink, marshy suck holes, and sneaky boat-headed Badgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Last Gather Season, our Enemy the Apsáalooke, killed our Walk-Around-Watchers. They ran us from our gathering places before Buffalo came, before we cached what keeps us. Some winters come like Rabbits, soft-round with snowy robes. Some winters slip down Mountains like scat, like gut-stench steam, winters that punish us with reek Waters and boney Wolves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Starvation winter came like bitter smoke from screech-dry Rivers. Our mouths turned blue with hunger. Winter itself— a hungry animal—snuffled on the high ridges, roared down Mountainsides, howled ice-cuts across wide-open. Trees snapped around us. Agai River whined. Our skinny Horses ate sticks and grew barrel-stomached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now we have so much meat I feel stingy with all Earth gives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pray all day as I work but tire of work all day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women work day into night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men clatter down Mountains with more Deer. More Elk, sometimes Antelope, and living thud-jumpy Rabbits. As I skin, I dream of gathering Camas roots and Gooseberries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Animals give their lives to our hunger. I thank them as I skin. I use every speck. My fingernails are red-Mooned and blood smell. After "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("C")]), _vm._v("eremony, I skin Deer, skin Antelopes, skin Weasels, skin Buffalo, skin Rabbits, skin Elk. My blood-heavy robe sticks to my belly. Blood-gut days. My teeth ache with beating and breaking bones. Scraping hides. Nothing is left but stacks of shatter bones to grind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 16. ",
      "epub:type": "pagebreak",
      "id": "pg_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("When Moon rises work saws in my teeth. Scrape scrape scrape.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You should work clean, Men tell me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You should be happy, my Bia says. We won’t starve come winter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia works beside me, her back a Hunter’s bow. We have shattered so many backbones, have pounded bone on bone for one slurp of marrow. My hands are as wide as my Appe’s. My knuckle cracks wake mice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe is the person all Hunters seek. He is arrow fixer and arrow maker. His bows are as bendable and as strong as Agai. His bows do not shoot arrows; his bows spin arrows to their aim. No Hunter misses with an arrow made from Appe. He fixes thick arrows or bent arrows, and whittles them down so they sing through Sky. His bows, covered with snake skins, are never lost. Appe’s snake-skinned bows writhe. Appe makes nets that capture more Agai than ten Men with large nets. His fishing spears chant through roaring Waters and spear mightiest Agai. His arrows whisper to the hearts of Deer and Elk. Hunters repay Appe with plenty meat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Three Rivers Come Together, heavy sacks of meat swing over us, dripping blood. Black and flapping Birds darken Sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("White Man called ă’-rah Crow. Now ă’-rah and Crow are one in my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their name ă’-rah like their call. Their name Crow like they look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crows rootle lice, shit on the blackened Tree stand, and scold Women working")]), _vm._v(" "), _c('p', {
    staticClass: "indent3"
  }, [_vm._v("                        ă’-rah")]), _vm._v(" "), _c('p', {
    staticClass: "indent4"
  }, [_vm._v("                        ă’-rah")]), _vm._v(" "), _c('p', {
    staticClass: "indent4"
  }, [_vm._v("ă’-rah        ă’-rah")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("until Debai sleeps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am small and Crows wing down to snatch entrails from my hands. Crows are a shining black lake of wings above, around me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 17. ",
      "epub:type": "pagebreak",
      "id": "pg_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Women look up from work and laugh when they hear me scream. They will take you, they tell me. We will see the speck of you in the Sky far far from us.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Black beads of ă’-rah. Crow eyes surround me, follow me. Crow eyes like small pecking winds of Old Women eyes. Like Old Women who know—me, you, "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Around. Crows bobble over stacks of bones pecking blood, their eyes watching "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Ways.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("ă’-rah")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crows know my prayers are puny. They know I want to go home to Agai. They know my want means we suffer from hunger the length of long winter. They laugh at me. "), _c('i', [_vm._v("ă’-rah ha ha")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At night the amber-green glow of Mountain Cats surround our camp, their eyes glaring in the Trees. So much blood makes us all prey.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec02",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec02"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 18. ",
      "epub:type": "pagebreak",
      "id": "pg_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of Moppo")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Debai rolls behind Mountains, clouds lift from oily reeds. Mists rise from nests of mud. Blood-stinger s s swirl. Bloodstingers s s swell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moppo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Water bush pitch and Sweetgrass burn all night. Smoke to chase Moppo back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Too Ott Lok, pitiful one, cannot outrun Moppo, cannot hide. They find him. They seek him out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Men say, Stay far from Too Ott Lok. Watch for him. He is not like other boys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We hear high sing hum-m of him-m long before we see him. At dusk, night Birds whistle-roar around him. Open-throat Bats whoop the Sky, descend like Appe’s arrows to spear Too Ott Lok clouds. Birds clear mists swarming Too Ott Lok’s head. Bats and Birds swoop his-s sweet blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We do not want him near our foot games. Children run from him and look back. Too Ott Lok, we call. Sticky gum catcher. Your blood is pine pitch and bee spit. Stay clear. Step back. Too Ott Lok comes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puh, Bia says. Too Ott Lok is our great gift. See. He was born to keep pests from us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia is All Big when we are with Women. They listen to her words while she puffs and shudders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor poor Too Ott Lok, Bia says. We should be happy he is with us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women look toward Bia with drum-stretch smiles. Nod like dogs catching scraps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we are alone, Bia tells me, Do not treat your own like always-baby. Better to leave one like him where you squat.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec03",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec03"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 19. ",
      "epub:type": "pagebreak",
      "id": "pg_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Days of no-work thief")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Combs Gut does not leave Too Ott Lok who is thirteen winters old. She lugs him with us—everywhere, her baby, her big afterbirth saddle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rancid pair. Worse than rot, Otter Woman says. Combs Gut only works for Too Ott Lok. No one else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Women strapped with baskets and burden-strap shoulders pretend Too Ott Lok is not sneaking behind them, scooping handfuls of berries—fistfuls—wolfing their work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Too Ott Lok and Combs Gut, puh. Bia says their names like they are mice in her basket. Puh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Too Ott Lok makes Gather Season long. Some nights, Combs Gut sings to him. If we listen, we hear her cooing without end. Most days, she stands behind him and rocks him in her arms, and together they pockell us as we pick chokecherries and gather high black moss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He needs me, Combs Gut cries. We all must help him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one argues. Women always work . . always catch up slow Men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Women are not looking, Otter Woman and I spit plum stones at Too Ott Lok.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Toothless Onion Wife gums her tongue, looks at the ground. Her silence winks in the mouths of other Women.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Combs Gut eats more meat than Warriors but is only rib skin. Year upon year upon year she has not birthed children, still her teats bloat with milk. She binds her teats with tongue leaves wound with gut string. When her teats leak she cradles them in Cattails, and her teats leak .. .. and leak .. ..")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How come she carries milk? I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 20. ",
      "epub:type": "pagebreak",
      "id": "pg_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("These things are not to be talked, my Bia says. Look with your gut, Baide then you would have no need for questions. Do not let your eyes hunt for no good. Puh.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia claps her palms over my eyes and shakes my head. You are here to work. Not weigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one tells Too Ott Lok to work. He is many summers beyond me and still not a Man. He will not be. Too Ott Lok is Womenwhispers, old Men long-looks, Children-laughs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia pats my back and looks off into far away. She has taught me Old Ways to survive. She tells me Women carry Water pick berries dry berries collect help plants dig roots dig potatoes gather firewood snare game gut Deer gut Antelope gut Buffalo gut Bear pound meat pound meat & berries pound bones sew robes pound more meat seek mouse beans smoke hides weave Fish catches twist Agai nets pick berries pound berries dry berries dry roots pound roots dry Agai dry meat pound Fish smoke Fish smoke meat store cache gather Lodge poles put up Lodges sweep Lodges brush Horses tan hides cook tend fires weave grass braid grass cut willows scrape willow sticks weave willow baskets chew hides scrape roots scrape hides gather black tree moss dig cooking holes cut bushes weave baskets tool root diggers snare lizards skin Porcupines make Porcupine brushes teeth quills wash roots find poison boil roots gather plums gather cherries grind bones gather clay burn cooking rocks gather cooking rocks make dog-carry carry cooking rocks carry children carry old ones carry firewood carry Water carry meat carry sacks carry Lodge poles carry carry carry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I fall asleep Bia is still talking. "), _c('i', [_vm._v("Strike stones for tools make awls weave Agai gigs make bone caches make Sheep cups make Buffalo cups dry Deer brains boil Deer brains clean hides in Water wring hides wring hides wring hides make frames make drying pouch for frames make sinew ties chew sinew ties roll hides in ashes then smolder fires")]), _vm._v(" . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 21. ",
      "epub:type": "pagebreak",
      "id": "pg_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Before Debai enters our Lodge, Bia talks. Women make Earth jars. Fish kettles. Women hunt. Join War parties. She says more but my listening grows lazy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No easy work, she tells me, only good work. See. All good work. All. Look at brush berries growing ripe to feed others. Look at Rabbits with their babies. Weta dig their food. Birds make nests, sit on eggs, chase us when we come close. Fox carries their babies to safety. Black moss grows as long as hair to feed us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Too Ott Lok carries nothing but his fat self, I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know work. I could speak my days, but talk is lazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am not lazy. I work. More.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia whispers in my ear with breathed wings of Bats. We should leave him. Puh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia’s thoughts scrape like sharp bone. Her thoughts belong to many Women. What-Women-will-not-say calls in me. They say "), _c('i', [_vm._v("Leave him. Leave him. Leave him. And go. Leave him and do not look back")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is not meanness, Appe says to me. It is survival.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is meanness, Bia says. Puh. Meanness for survival.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec04",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec04"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 22. ",
      "epub:type": "pagebreak",
      "id": "pg_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Days before Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On good days, Onion Wife tells Running Woman stories. Every Woman stops digging, stops picking, stops rooting to hear Onion Wife. Running Woman could hunt. Could trap. Could fight. Could weave grass baskets. Men, Women, Children watched Her like She was Debai, like She was Bluebird’s light in dark Trees, like She was cold Water on a hot day. We watched Her sick with want for Her. She was smells of cook fires and Stream Waters, small Trees high in Mountains. Her skin glistened like Fox fur. Her teeth were strong as Elk teeth, white as River clay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One cold night when the People were hungry, She returned from Far away—Her Horse weighted with Buffalo, Her dog-sled heavy with Antelope and Deer. We danced. We ate. No Man, no Woman was jealous of Her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She left us in the Season of Thunder. Kidnapped by the River Lodge People and taken far from us. Our Men chased after the takers and returned sick and skinny. We knew She would escape these Enemies. For many days, we cried and waited. We looked for Her. We searched for Her. Every wind carried Her scent. Every Coyote sniff was Her breath. Every Mountain Lion cry was Her calling for us. For a long while People said they would see Her, a "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("L")]), _vm._v("ightening shot there, and then gone. Others swore they saw Her by River weaving rushes. We looked to find Her shadow cast like River shine through high ridge Trees. It has been a long time. We wait for Her until there is no One to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Onion Wife claps her hands. You will see. Running Woman will return with drifts of Buffalo robes and pale pink shells. It will be like She was never gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You must gather what you can now. Fill your baskets to the top. When Running Woman returns, She will not find us lazy.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec05",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec05"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 23. ",
      "epub:type": "pagebreak",
      "id": "pg_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Night of too-good-for-you husband")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Bia has spoken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Long ago, Appe promised me to Blue Elk. I am told when I am older, Blue Elk will take me for his first wife. This is my Appe’s way of tricking, I think. If other Men believe Blue Elk wants me—they might want me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now old Women sigh. Young Women snort when they near me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk is "), _c('u', [_vm._v("all")]), _vm._v(" Women desire. They chase him, bring him hump fat of Buffalo, bull berries, Water potatoes, wet chewed hides, Water baskets. Every Bia wants to snatch Blue Elk for a monappe. With Blue Elk you will never go hungry, never worry about Enemies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women whisper Blue Elk is more. I watch them watch him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Debai pools red and night turns the blue shine of his hair. When mint and sting weed rile me like black poison arrow tips fallen to sharp grass, and Men watch for rainbowed Trout to stub against weirs, Blue Elk crouches in fields, gathers sage and needle grasses, and then rubs a fire that burns like lit Buffalo bellies"), _c('span', {
    staticClass: "ash"
  }, [_vm._v(", ")]), _vm._v("yellow in the vein-colored dark. Women watch as Blue Elk, sure as Fox, winds to Water, his torch light blazing above him flicking tiny Stars into night’s bowl, "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Around him tiny Stars raining, never catching brush on fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men waiting for Fish run, open their mouths at the sight. Blue Elk lifts his torch and Fish gather to him, flapping Water. He gives his torch to Stands Tooth. He scoops up Fish and tosses them onto the bank, over and over again, until Blue Elk himself becomes one with Fishes. Blue Elk, his hair to his waist, belly flat, turns from Water to bank with armloads of Moon-speckled Fishes. His Song lifts like cedar smoke, like Womb ache. Silver curves of Rainbow Fish dance around him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To be one with him would make Turtles sing, Women say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 24. ",
      "epub:type": "pagebreak",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Puh. How he looks matters less than mouse turds, Bia says. Who cares if his hair shines like Moon light? Who cares if his poker is as big as a Lodge pole?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Foolish Women. Foolish girls, Bia says. Do you not know arrows glance off his chest as if they know him? When no Deer are to be found, he finds them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia speaks as loud as River roar. His looks will become as dry as old creek mud. Puh. Your belly will never rumble with Blue Elk in your Lodge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Women only gawp, only chitter chitter chitter like branch rub.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec06",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec06"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 25. ",
      "epub:type": "pagebreak",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of blood sign")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Small Elk left his Bia’s side while she picked berries. Our whole camp made a game circle and we flushed toward each other, beating the ground with branches, closing in on ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deer rattled bushes in the center of our search. Badger sniffed air and then clawed back into his hole. Weta and her two cubs shot past us shitting berries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We should have gathered up and left before we lost Small Elk, I tell Bia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now a bad scent follows us. Death rattles in the leaves and tickle grass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women arch their backs and hiss as they enter River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are in the Season where Women blood scent is sticky. Old Women snuckle their gums, and say—Women-blood fouls Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia says, Women blood scent is winter calling us to prepare. See, Bia says, Bramble is as red as Womb. I will help you prepare, my Baide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am not ready to be Woman. Women-blood is strong enough to kill Men. Women-blood curdles Agai runs, rusts stones, salt clay, Elk trails, Turtle shells, Earth cracks. Women spill birth blood, and walk. Women-blood drums to all living. Our blood is our Song into "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("S")]), _vm._v("easons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My breasts are flat. My muscles flinch when I move. I am as muscly as a paw cat and far")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("from my blood time. I am not ready to lie beside Blue Elk, to open to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You will, my Baide, Bia says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I will be like Running Woman, I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia laughs. She laughs so hard she spits. You have a slow start, she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We shut our eyes before we dunk beneath pull currents, afraid we will see edges-of-dark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 26. ",
      "epub:type": "pagebreak",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bia hears Pabihiano hissing from River’s edge, laughing, playing tricks. Can you not hear them? Pabihiano wait to net us in the Season before Turtle sleep, she whispers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I do not tell her I hear Pabihiano when I am alone. They call to me. They rustle in River Tree overhangs. They tell me when I am too close to suck holes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("G")]), _vm._v("ather "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("S")]), _vm._v("eason rough as gopher fields, Ogres chatter in River foam but only Appe sees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They have left their stone houses and bunched up here, Appe says. He sniffs. Up River is clogged with Sickness and bones of the Dead. Do not look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shiver when I enter Water. I watch for change.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec07",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec07"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 27. ",
      "epub:type": "pagebreak",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Days of Earth yawn")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After Rutting Season the days are hot as summer stones and promise sweet roots and plenty Deer, but just below River skin, Death pulls. Rattlers shed their long skins along hilly rocks and fury-strike any move. Lightning crawls Earth like lizards, shivers over gather paths, and the paths of all animals. Thunder rumbles our feet and startles blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now is the time young Women see only each other, and only as Enemy. They hear their own Womb rattle and ready themselves to strike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Move out of their way, old Women tell young Men, and laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For young Women, there is only one Enemy now—Bawitčhuwa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women eye Bawitčhuwa. They watch Her like camp scouts and stretch their eyeballs to keep Her in sight. If Bawitčhuwa spots them, they play blind. They play they look to distant Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa is fourteen winters and ready for Husband. She is as ripe as late Season snow berries, and poison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even old Men puff big when Bawitčhuwa is near. I have seen Walks Back Night stretch before Her like a dog wanting scratch, his cockhead blazing. She snaps Her teeth at him and he rolls. If he follows Her, Old Women spit at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa’s Appe promised Her to Rabbit, and when Rabbit died, Her Appe told Her She could choose. All wives hope She chooses not their Husbands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men watch Her. Hope for Her. Bring gifts. Fish as long as a short Man’s legs. Hunks of Buffalo. Deer hearts. Men lick their lips, say when She has babies, Her milk will drown us all. Her Appe and Bia grow as greasy as fat Bears. Soon they will become as big as Buffalo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa comes to River last. She does what She wants. She perches on juts-over River rock and pulls Her robe off over Her head and stands naked too long forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 28. ",
      "epub:type": "pagebreak",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Her skin is River bramble in early Debai-light. Her nest-hair is as sleek and shiny as Beaver.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Women splash Water on their ankles and turn to watch young Women and Bawitčhuwa chipping for battle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Young Women peep Bawitčhuwa, and then turn their backs to Her, hunch their shoulders together, laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puh, Bia says, Show their want; lose their power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women say, Bawitčhuwa’s legs are so strong She could squat and grind all day and never tire. Forget good work. Forget children. While She huffs over your Husband, you will work to feed Her. With those big hips, they say, SHE will have so many children we will all starve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In winter, when food is scarce and the People are hungry I shrink to bones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa never loses fat. Her breasts remain the size of Buffalo balls, firm and high.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her ass as plump as a Mountain Ram rump.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puh. She is lazy, my Bia tells me, not the worker you are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am dry and hard and skinny. Not like Bawitčhuwa with Her berry-stained fingers, Her plump greasy lips. I have dressed over a hundred animals since we set camp. "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("teeth click in my gut. Crows smack my name in their black leather tongues and call their Brothers to my blood-stiff hair. I wash with River clay and cannot wash stink from my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Look to "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll, Appe tells me. You are "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll you see. See "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll good. Appe opens his arms. See light flitter like Birds on silver leaves. See Beavers, slick as minnows, chew down Trees, and if you are quiet you will see Weta’s eyes watching through leafy branches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe places his palm over my eyes. Look inside, he says. See the stories you hold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see long back. Night glows brighter than Agai coming up River. Up from Earth, a smell rises from where Pop Pank stands, "), _c('span', {
    attrs: {
      "aria-label": " Page 29. ",
      "epub:type": "pagebreak",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("so sweet, so fullish, blossoms puffing in Budding Season cannot fill my nose. Outside Grass Dance circle, Pop Pank stands so quiet I hear her teeth clicking. I see Men and Women dance for grasses to grow for Deer and Elk, for "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll animals, for All Fish, for All People. A scent stirs in my marrow. A gut pot boils. A snake hole waggles. The quivering scent of Earth yawns. Grasses writhe up from Pop Pank’s River dampness, her red Agai heart. Grasses rise from her small shaking body.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men fall to their knees, their eyes wurtling round.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec08",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec08"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 30. ",
      "epub:type": "pagebreak",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Days of "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ene’e")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Water is so cold I am breathless. Bia mouths for me to follow and we return to River bank to watch. Bia is trouble-faced. She squints into Water light. She wraps me in my robe and gathers her blanket and together we stand shivering. A deep smell shudders over Waters, sweeps across River in ripples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see now what Appe sees. Ogres bob up and then down, Their stony heads sleek and round from Water rub. Women perch on rocks, not rocks, mistaking Ogres for places to rest, not seeing loll of Ogre heads rise between their legs as they lean forward, then back, and kick their feet in Water. Ogres’ stony eyes roll as They watch Women bathe, as They wait beneath and beside Water to wed them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do you see Them, Bia? All along the Water line?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia cups her eyes, and looks. I cannot, she says. Only Earth-close People see Them. The Old and the Young. The Ones given sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Mud Squatter plops into the Water and heads to where Water is angry, where giant Ogres cackle at boulders. Water spits white and gurgles round and round Mud Squatter while Women shiver together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mud Squatter teases Ogres. I can tell. She smacks her lips at "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("Th")]), _vm._v("em and "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("Th")]), _vm._v("ey roll under her waves. Mud Squatter swims where we cannot, where we are afraid, and is happy. She putters and puffs. Her hands paw. Her head bobs in her own splashes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Debai squints at Mountain edges and we shield our eyes to see Mud Squatter eel across the widest wound of River. She becomes Beaver-sleek past Water so deep, so black, to look there is to become blind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far below her, "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("caves chicker with the winking Dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Mud Squatter reaches the far bank, she hefts herself up and rests. She rests for a time too long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 31. ",
      "epub:type": "pagebreak",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Young Women call to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leave her to herself, my Bia tells them. Can you let old Women rest?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mud Squatter sits up and pats her face. She cups her hands round her eyes and looks around as if she does not know where she has landed. Far above her, cliffs rise too steep to climb. Mud Squatter s-shakes her naked body and climbs anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ahhh, my Bia groans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mud Squatter taps here and there and slowly makes her way up cliff wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Halfway up, Mud Squatter stops to stand where Mountain Goats have stood. Rocks tumble past her, clatter all the way down and splash into River. No one should be where Mud Squatter stands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far below her, green Water wriggles, and waits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia fists her mouth. She will fall, my Bia says. That foolish old Woman will fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank dips beneath River and boils Water with her breathhh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is she doing? Bia asks. She should be watching her Gagu, not calling noise to herself. Puh. White Man knew Pop Pank was special but Bia says work is worth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mud Squatter grasps at horsetail clumps and climbs higher, higher yet, and comes to top bluff where she hand slaps here there searching for holds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At last, she fists Bird weed and kicks herself up on the rock shelf and rests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Bia taps my arm and points her chin at Bawitčhuwa floating in Water. Bawitčhuwa smiles a River bug smile—knifes her arms and legs—and skims top Water. If Mud Squatter fell, Bawitčhuwa would own the old Woman’s Death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far above us . . Mud Squatter stands on the edge of the World . . and stretches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 32. ",
      "epub:type": "pagebreak",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Women back up to the River shallows, their eyes on Mud Squatter, All Women but Bawitčhuwa. Bawitčhuwa stays flow-ting. Smile-ing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("High above us, Mud Squatter’s shadow quivers through skinny Trees. When she steps from the shadowy saplings, Debai ticks through tall grasses. Watery blue branches sway as s-s-s-she edges her way out to an overhang thin as a s-snake’s tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women wave their arms. Come back, they shout.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Birds wing beneath the shaley plank Mud Squatter walks upon. Rocks split beneath her feet and plunk|splash to Water. A breeze smokes upward and then dust spittle comes")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("down")]), _vm._v(" "), _c('p', {
    staticClass: "indent3"
  }, [_vm._v("down")]), _vm._v(" "), _c('p', {
    staticClass: "indent4"
  }, [_vm._v("and down")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("again and")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("scatters over River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Earth’s crumbly tongue, Mud Squatter stands Weasel-eyed. Woozy. Her breasts wobble as she peaks her hands above her head and smalls herself. She killdeers off the ledge and hits Water like a coup crack, her "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("spraying upward fizzing white. We smell pine-needle hiss of her body before she becomes River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wait for her to surface until our dark selves stretch tall. Sky becomes color of clay. Mud Squatter has become only quiet, only sounds of Water lapping and rushing on in ripples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ogres wink at us in River light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank smiles and drifts along in swirling Ogre-crackling River bends as if nothing is wrong, as if nothing is wrong at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women slap Water skin and Water rings out. They call her name, her name-no-longer. "), _c('i', [_vm._v("Mud Squatter")]), _vm._v(". Spit sizzles in the pitch of their voices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia holds me as we walk back into Water. We shiver beside one another. We know now. River has taken Mud Squatter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 33. ",
      "epub:type": "pagebreak",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bawitčhuwa gathers her robe and leaves as Women begin to wail. But when Men come to River, their eyes wound-dark, Bawitčhuwa waits and watches. Children cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk runs past all of us. He runs so quickly, leaps from jutsover River rock and spears into River headfirst and I feel the "), _c('i', [_vm._v("cedar wind of him passing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe squats beside River and watches currents looking for any sign of Mud Squatter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk is gone too long and Bawitčhuwa returns to stand on rock Blue Elk leapt from. She disrobes again slowly this time. And as Bawitčhuwa enters Water her breasts float. Her nipples become as large as thimbleberries. Foam gurgles from the mouths of Ogres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia sees "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("IT ")])]), _vm._v("first. Narrow edge of Monster moving through Water, lipping waves. A back hump stirs Women and one after the other Women spin, jump, squeal as Monster threads in and around us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia does not flinch. She grips my hand and makes me stand still beside her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk’s breath bubbles to the surface and he emerges like Otter, shakes his head, lifts his hand to other Men before he dips down again into black Water caves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Look, "), _c('i', [_vm._v("look")]), _vm._v(", Bia says. River dimples with light. S s sw-wirl of swift feet. Beavertail currents. Purled wash of skin. Small bubbles swarm my knees. A large Fish brushes scales against my hand, glints silver past my legs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia cups her hand to my ear—"), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Mud Squatter")])]), _vm._v("—she whispers. We are not to speak "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Mud Squatter’s ")])]), _vm._v("name, not call her up from River that has claimed her.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec09",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec09"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 34. ",
      "epub:type": "pagebreak",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day speak at edges-of-dark")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia stops working. She sits away from camp, away from firelight and Debai light. I see the old Woman she will become. In the nestshade of mice and winter Birds, she burrows in dark stickery brush and does not flinch. She behaves like Deer stalked by boys. She will not go to River to bathe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women cook for her. Come to stand beside her. I hear Onion Wife’s stories riffling beneath wind, striking low rocks, murdling in the tall dry grasses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Should I beat her from the brush like a sage grouse? I ask Appe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do not bother her, Appe says. She seeks herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pound Elk and berries to paste I dry into rounds. I bring Bia seeds and Elk cakes. I wait beside her but she does not eat. She does not talk. Her eyes are unseeing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cameahwait brings her steaming liver but she does not sniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stand, I tell her. Walk. If she stays to herself too long, she will be left. They will call her crazy. They will call her Woman Who Sits in Sticker Bush. Debai rises. Nights go. Crows peck her food. Mice rattle beside her. I climb into the bushes and push at her from behind. I grab her hands and pull but she has no grip. Days into days, her face remains as beaten as a fire stick. Pelted. Yelled. She does not move. She is not Bia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I work for her and for me. I carry her Water. I grind her meal. I scrape her Deer bones. I snare her Rabbits. I carry. I carry her. Many days pass and she grows skinny as Coyote in winter. She is gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I go alone now to River. When I step into River hole and splutter and bleat, and go under, light changes and crinkles beneath me. I hear my heart drum . . Far away I hear Bia . . Bia calling . . Bia calling me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then Bia is splashing toward me. Bia is moving Water. She is swimming. With one arm stronger than Antelope legs, she pulls "), _c('span', {
    attrs: {
      "aria-label": " Page 35. ",
      "epub:type": "pagebreak",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("me from River dark. She hefts me like a Buffalo leg over her bony shoulder. Everyone turns to look. She falls down and cradles me like Combs Gut cradles Too Ott Lok. Her tears spill over me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Baide, Bia cries and cries, My Baide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I try to stand. I try to push away. I am too old for foolish tears but her grip is fierce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All night she watches me like a dog eyes a boil pot for drops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why does she cry? I ask. I am alive. I am here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cries for gone "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Mud Squatter")])]), _vm._v(", Appe tells me. Tears are sneaky. They come when we do not want them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we go to River Bia watches me. She catches me when I slip on slippery rocks. She follows me tight as blood bugs. When I stretch my arms to yawn, I strike her. Young Bias titter at us while their babies splash in Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank swims up beside me. I will teach you to swim strong, Pop Pank says. You will not go under.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank climbs like squirrel. Spears River waves like Agai. Leaps like Antelope. She is muscly as Agai born of Water. I cannot learn her ways to swim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank slaps my belly, my legs. Make yourself skinny, she says. You will glide like an arrow over waves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia elbows my side. Puh. Do not be stupid and try her tricks. It will get you Dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia thinks big of me. I would not swim in River shadows. I am afraid of edges-of-dark, afraid of Wood and River Monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank lives at the edges, places where we become our most power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe says Pop Pank prepares for the day she will have need to sleep in Water. His eyes become sharp as awls. He knows.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("In early light I am. Naked. Chest deep in Water. All Around me reeds are as tall as saplings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 36. ",
      "epub:type": "pagebreak",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I dig with my toes for bulbs, potatoes, sweet roots. A rush of bubbles floods the surface . . boiling . . boiling . . I stand unmoving . . Let Water clear. Circles lap from Cattails. Calm. Slow. I breathe in and dig again. I have been collecting all day. I have wandered from Bia and removed my robe. Wind carries Bia’s voice, her talk, the small sound of her becomes like Birds skimming River hatch. She talks on, not knowing I no longer hear her words.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between my feet brown stones, clear speckled River rocks. Amber green, the color of Blue Elk’s eyes in Sunlight. I look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A rock looks like a nose? A glint. Fish scale eyes? Light loosens dark reeds. What do I see?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blood pecks my skin like tiny Birds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rises from the silty River bottom where lazy Fish sleep. Her hair snakes the way roots twist in pull-Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drop my basket and run in thick mud, Water gurgle, a bladder push of waves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hear laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Come back, Pop Pank says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I turn, she is already turning back—turning back— to Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I run to camp where nothing has changed. Boys practicing. Men testing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Women stirring pots. Girls gathering to play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Walks Back Night runs around and around camp, his Manpush like a knife sticking out below his bloat-gut. All day he runs, runs and runs around camp, jumping over cook fires, bothering Women working. Around again. His Man-push flapping. His humped back shining. How many Rutting Seasons has he plagued us? He is as old as wind and as dry as rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women watch him with tough eyes and speak behind their hands as he passes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 37. ",
      "epub:type": "pagebreak",
      "id": "pg_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I have big ears too, he puffs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Women laugh like girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hide in the tall grass where no one can see or hear me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Pabyhina ")])]), _vm._v("I whisper there.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec10",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec10"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 38. ",
      "epub:type": "pagebreak",
      "id": "pg_38",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of everybody laugh good husband")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Appe, Blue Elk, and No Bear Is His Enemy come together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through the Lodge flap I see them smoking. I see glazed scars, the color of Bawitčhuwa’s lips, on No Bear Is His Enemy’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia sits big beside me—snarl-mouthed—as other Women look over from where they work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe, Blue Elk, and No Bear Is His Enemy talk on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Children shriek and run, stop to stare, then run on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon enough Women leave their work to see what is going on inside our Lodge. Steals Night stands in front of me looking as if I am Water she can see through. She cups her ears. She leans forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Go back to your chores, Bia tells Women. There is nothing to see here but my Baide being promised to our greatest Warrior. What do his looks matter to my Baide? What of his power and many honors? Puh. My Baide is strong and can have any Man she wants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women gather around me like hair snakes. I feel the nettle of their eyes. The bite sting of their Wombs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This one, Bia says, bumping my shoulder with hers. Something must be "), _c('i', [_vm._v("wrong")]), _vm._v(" with her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She would rather pound meat or search for mouse beans. She prefers work all day. Puh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now see Warrior—great provider Blue Elk—chases "), _c('i', [_vm._v("her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I lower my head, pull quills through tight teeth. My face prickles. My ear threads")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a trace, a blood track of Men and their talk. I hear faint sounds of Water, boiling wind carrying "), _c('i', [_vm._v("his")]), _vm._v(" voice. Blue Elk talking to my "), _c('i', [_vm._v("father. My Appe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look up and see Pop Pank leap over two small boys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men push their heads out of Lodge flaps to see if they should know what.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 39. ",
      "epub:type": "pagebreak",
      "id": "pg_39",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Pop Pank runs so fast when she stops short River-rain trails her.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Run, Pop Pank tells me. Trouble is coming. She speaks in scraps. -ka’ah -kacih -katyn -kepiih.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pop Pank gets down on all fours and threads through legs of Women.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I warned you, Pop Pank says.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Before Bia has Pop Pank tethered, Bawitčhuwa ruts toward us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("See, Pop Pank says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa snatches up ground at Weta pace. Women gather close as Bawitčhuwa tugs, yank-scalps their hair with fists. Step aside, She cries. "), _c('i', [_vm._v("Move")]), _vm._v(". She spits. She grabs a dead fire stick and waves it at them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They do not strike back. They know what She has come for. She has come for Blue Elk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her greedy-gut blows up air around us like a Water bladder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to run. Bawitčhuwa wants Blue Elk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women collected for gossip want blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa is not interested. We are Birds of no big matter. She yowls for Blue Elk. Her voice claws like dying animals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa turns toward me. Her eyes like Cougar eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes on me, eyes on me. On me. The vein on Her forehead so big I could pluck it with my thumb and pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia wobbles up from ground to stand in front of me. Women titter like seed Birds in Trees. Brings Home Wolf claps her hands. Gut work and sweat glitter like Crow peck spatter on Women’s faces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They circle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know to look away. Know not to move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand . . back one . . small step . . from Bawitčhuwa . . as the Lodge flaps opens and Blue Elk steps forward. The bluster sight of him . . stops "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll . . Everything . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 40. ",
      "epub:type": "pagebreak",
      "id": "pg_40",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bawitčhuwa pounces Blue Elk and Blue Elk stands as still as sighted "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("D")]), _vm._v("eer. Everyone sees only Bawitčhuwa and Blue Elk now. Those two together. My stomach is Buffalo gut glowing with sour light, scraped out. I am dust that twirls and fades in cross        winds.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa’s head reaches the curl of his throat. She snatches at him. His skin whitens beneath Her finger grips. Blue Elk does not move. He stands so still I see his skin ripple. Muscle waves twitch over his smooth chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No Bear Is His Enemy slips out of our Lodge and leaves like a Fox with Turtle eggs, and when he looks back at his son in the center of Women, he smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Catches Bone steps up beside Bawitčhuwa and pat-pats her back. Come, she says, her voice small.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think Bawitčhuwa will let go, but She swathes Her arms around Blue Elk’s neck so tightly She hangs from him. Her feet. Her body. She has made Herself his Game sack. Hanging. Slack. Spoiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk has become Deer. His watch on distant sage. Sage powders the air and Blue Elk waits for change. Waits for flinch. For sign. For chance. To leave. To bound away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Could it be he cannot see what we all see in Bawitčhuwa? What young Women see?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The gathered Women become stone-faced. Stopped. Stilled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk steps so quickly away Bawitčhuwa clatters to hard ground. A pinch, an awl prick of shame. Only Onion Wife crouches over holding her gut-wheeze of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa made herself ugly with want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia waves her arms to curse Women from Bawitčhuwa. Women laugh . . laugh and")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("laugh . . and far away They slap each other laughter. "), _c('i', [_vm._v("Cackle caw crow")]), _vm._v(". Their laughter wakes Trees. Hungry "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirits")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 41. ",
      "epub:type": "pagebreak",
      "id": "pg_41",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bawitčhuwa gathers herself Together. Her blood circling and circling in her veins, in the River of her Life. Her Life bigger than want. She gathers Herself together and becomes all-Women-blood. She becomes a branch struck by Lightning.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "padd"
  }, [_vm._v("She Becomes Here Now Never Gone")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She strike me with Her look.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She strike me days worse than Death.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She strike all my children up ahead where I go"), _c('span', {
    staticClass: "padd1"
  }, [_vm._v(" away from me.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenth"
  }, [_vm._v("She strike me gone. Gone to where our People do not go. But even more—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She strike the jittery Stars can never lead me home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe says, Men curse Women with Women.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men say, Bawitčhuwa is so beautiful we will never know darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Onion Wife says, even in shame Bawitčhuwa shows the power of Women. She says, Men do not know We Women gather ourselves as teepee poles and build new Lodges. We overcome want. What we have is bigger than want. We are the Heart of our People. Jealousy is weak thread that binds nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia says, Onion Wife does not know Bawitčhuwa. Puh.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec11",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec11"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 42. ",
      "epub:type": "pagebreak",
      "id": "pg_42",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Night morning comes for me")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wake, Appe tells me. Come see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe’s face is shadow lit, the face of Rock cliff who has seen many things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia walks beside me, places her fist to her mouth, and we stand. Around us hills rumble and plume. Rising plumes of dust in the Thunder strikes of Horse hooves. I see Bā’bi—my Brother Cameahwait—riding to my Appe, to my Bia, to me. Dust feathers behind Cameahwait, around him everywhere. Men ride beyond him, toward us. Round and round they come. Down the hill they come. In a wide wide circle they come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the kicked dust, I see him—Blue Elk in the middle of their circle—Blue Elk walking to me. On his shoulders he carries Antelope. On his Horse more Antelope. Blue Elk’s skin is the color of smoked hide, smooth as River wash. Shining. His hair is long and so black each strand echoes blue"), _c('span', {
    staticClass: "ash"
  }, [_vm._v(", ")]), _vm._v("liver blood. He comes toward me, cool of River Canyons, night red fires, wind of Trees, dust smoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He comes toward me in the center of day-ever-same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the rise-dust, People gather. In the Horse circle, Men yip. Women trill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk places Antelope before Appe. Blue Elk gathers his Horses and ties them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("beside our Lodge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one speaks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Bia sets her chin to chest and gulps air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Appe lifts my hand palm up and Blue Elk places his hand over mine. He is tall over me, tall as Tree shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moon rises over Trees . . River Ogres gurgle. Women mouth my name. How can this be?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa cursed me to : : second ugly wife, cursed me to lost children : to an old Husband who squats behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 43. ",
      "epub:type": "pagebreak",
      "id": "pg_43",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Now Blue Elk plucks me. I am a ripe summer Prairie. I am the berries of distant Mountains only "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Sacred Weta ")])]), _vm._v("eats. Blue Elk is my age and then half my age again. He is a young Man, a Warrior, with long days ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am a mouse shaking in the tatter leaves.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec12",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec12"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 44. ",
      "epub:type": "pagebreak",
      "id": "pg_44",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Night of too soon dark")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight my People dance and the dance goes on. Trough fires burn into star smoke night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I squat in bushes to piss and hear grunting Man. Patter of his piss on leaves. A yellow creek runs toward me. I make no sound. I find wet grass . . soft leaves . . Weta quiet . . Deer and Elk and Moose quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On distant bluffs surrounding camp, shadows of Men crouch in grass. They are not Walk-Around-Watchers. While we danced, Enemy gathered around us. While we celebrated, Enemy waited in darkness. I hold my breath and run to Appe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe whistles smoke through his teeth, screech-hoot, gathers his arrows, and heads to where I hid from Man. From Enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If we must leave, Bia says to my Brother Cameahwait, Come back here. Take your Sister down to River where Sweetgrass grows. Hide and we will find you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia takes my hand. Cameahwait follows Appe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We won’t stay outside Lodge, Bia says. She sits on her haunches and pulls me down beside her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Bia was young, her Lodge was knifed open while she slept. Her Sister was wounded. Her Bia too. Now she no longer waits in Lodges at threat of Enemies. She has told other Women her fear has made her strong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women crouch in bushes with children. Always Alone holds her hand over baby’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wait in darkness together, apart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Moon s-laughter-s clouds, Bia throws a robe over my head. I peer through a small opening when I hear hollow thunks of arrows hitting trees. One flaming arrow charges Sky. I listen to rounds of arrows released. In the place where I squatted arrows rain down. At far edge of camp, one arrow sizzles in grass and catches fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 45. ",
      "epub:type": "pagebreak",
      "id": "pg_45",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bia holds me close. We hear a hundred bait teeth snaps. Branches crack. Voices rumble.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Men whoop laugh. Men shadows rise tall in the wake of small fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They found Dodges Woman walking the rim of camp. A watcher. A protector.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was nothing, the Warriors say. Only fear-chatter of young Woman afraid of the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women gather green robes to snuff out flames. Bia stands tall and wraps her robe around my shoulders. She hisses at me behind tight teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("See the trouble you caused, Baide? On a good night with good "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Around you. On the night you are claimed by our great Warrior, you cause trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Look, Bia says, Blue Elk walks toward us. See. I told you. No one wants a trouble girl. But a great Warrior? Puh. Dishonor scours his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk threads through quivering grass. Warrior quiet. Weta quiet. Starlight tips Mountains blue and "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll become one. River fields and Stream shine and Animal shiver and his black hair, "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll blue. I see his breath smoke like the thinnest strands of silver gut. He stops before me and lifts his torch above my head. I am the Fish he catches now. I tatter in light that spills from his neck bone to his ankles. Torch light. Blue Elk light. The light of Warriors. His body is an arrow, his "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("M")]), _vm._v("an-push hard against his breechclout.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe—drunk with War fires—grabs my shoulders. My Baide is dreaming of Men pissing in bushes, he says. She is almost ready for you, Blue Elk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bawitčhuwa stands at edges-of-dark. Her rancid eyes glower at me. She punches me with her eyes. She belches Skunk Death and Bird claw. She counts coup with her coup stick of bone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Puh. She is less than mice chew, Bia tells me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 46. ",
      "epub:type": "pagebreak",
      "id": "pg_46",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Bia does not know "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll fear. She does not know Women whispered behind their hands and called her crazy when she slept in bushes. She forgets that once our Women clobbered Enemy Women, and scalped them alive. If Bawitčhuwa is less than mice chew, she is the Vole that climbs up Enemy ass. She is the "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("S")]), _vm._v("ick at the edges-of-dark.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Men search fields and find no Enemy in grasses. No Enemy Horses. No Enemy Horse plop. No One. They find only Owl-scared Rabbits, scudder of Voles, and Dodges Woman, who stands guard all night and walks the rim of camp to watch. Dodges Woman is a new Night Watcher. He is young and wants to be a great Warrior. I fear I have shamed Dodges Woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You will bring him your best basket filled with berry-pounded meat, Bia tells me. You will cook for him at Debai wake.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Deep in my body a baby Bird sleeps. She flitters up and away from my trouble. Away from Womb ache, and age. My bones are light as Muskrat bones. My teeth are small as Rabbit teeth. I quake under Buffalo robes so heavy my ribs bow. Beneath the Womb-glow Moon, Enemy Warriors swim downstream and wait for us, their breath wheezing through reed holes.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec13",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec13"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 47. ",
      "epub:type": "pagebreak",
      "id": "pg_47",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of not-spoken")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story is ugly, Bia tells me, when we are alone in the Wombdark haze of Mother talk. We stand beside fire’s roar, snap of wood, whoop of smoke, where even Weta sharp ears cannot hear. Here, Bia protects me from Bawitčhuwa spatter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You are old enough to know Onion Wife lost her Baide to three Men who once were good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia crouches, tugs me to Earth, where dust powders our hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia shakes grass around us, lights sage, and Smudges me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One day you will hear the story from Onion Wife herself but I tell you now so her words cannot harm you. What I tell you will wake you to "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Around .. .. .. .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To wake to "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("A")]), _vm._v("ll Around means my story will change you from now into on. You have been all along dreaming. What you know to be Beautiful is Ugly. You will see blood traces of the Dead on rose thorns where you gather food. You will know what you have not been told. You will see liars and thieves you once thought were good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia covers my shoulders in grass . . I hear her heart drum . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("River voice settles. Bia’s voice falls to dust and smaller sounds rise. Mint whispers beneath dry brush. Moon clouds powder Sky. Mice rustle so close Milk pods jickle . . jickle jickle jickle. Muskrat scritters in marshy Water gnawing splinter caps.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("When Bia speaks again her words wobble on rain-beaten rocks. She calls upon the power of her tongue. Bia becomes long-ago Song, bigger, wider, All Around. She chants in the ways of Women to keep Men away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three Men brought back a wasteful devouring "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit")])]), _vm._v(". Bia spits. They brought bad dreams of what is yet to come from far-up River. Because we are Agai People, Bia says, bending low, we feel change along Water lines. Bia flaps her arms like she is Crow flying over Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 48. ",
      "epub:type": "pagebreak",
      "id": "pg_48",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I feel transformation. In the deep coiled grasses and in the places we sniff, but do not enter, Debai trickles downward, and the smell of what has been, and what will come, turns poison.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three Men, who became not-our-own, carried tatters back to us—scalp-flesh torn from young Women, "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("meat hiss, their cock-stink abomination. They were not War party, not Hunt party, not scouts. They brought back nothing, not even themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia’s story is sticky in the telling. Each word latches her tongue. Her story has become a difficult journey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They attacked White Crow as if she were Enemy. They broke her wide open, tore her Womb. Puh, she says, White Crow became less than Marten tongue, less than unlicked bone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia fastens her eyes on the grind-stone Moon. River flushes the watery color of rinsed blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Listen, my Baide, even stones hear what I am saying. What happened to White Crow has given ugly ways a path to all Women. Now "), _c('i', [_vm._v("men")]), _vm._v(" with War eyes—with pouches of broken teeth and scalp-ripped flesh at their hips, with fingernail-Moon-gouged arms, and no-good stink of "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("W")]), _vm._v("omen used . . "), _c('i', [_vm._v("men")]), _vm._v(" with nothing to pour their seething into, but Women, see Women . . as less than, and return to us hate. Hate, an infection, never before and unforeseen, and now All Around and coming. More and more hate come. Like craziness, hate come. Like Badger foaming mouth, hate come. Like "), _c('i', [_vm._v("men")]), _vm._v(" at War with nothing, hate come . . Like Flatbird’s vision of White Men swarming Rivers, hate come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like stingers in the ribs of dead Buffalo who no longer recognize Death, "), _c('i', [_vm._v("men")]), _vm._v(" come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia’s words are stick pokes, must-listen words, gut speak of Women to heal, to call back,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("to make right what has been wronged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 49. ",
      "epub:type": "pagebreak",
      "id": "pg_49",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Used to be Water Babies were our only Monsters. Water Babies who called Women to their Deaths. Now "), _c('i', [_vm._v("War")]), _vm._v(" men are our Monsters. "), _c('i', [_vm._v("War-men")]), _vm._v("-want glistens on Women like pinecone sap at Debai rise. Crazy-want walks up River, up from the maggot hearts of "), _c('i', [_vm._v("men")]), _vm._v(" who have become what they should not become. "), _c('i', [_vm._v("men")]), _vm._v(" who let their War stink invade our "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("Sacred ")]), _vm._v("Lodges, our "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("Sacred ")]), _vm._v("openings.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Women must find the path for our People to go on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember what I am telling you, my Baide. We Women can shatter rocks with our anger. We can pound Earth and call up broken Womb-heart of Women or we can call "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Onion Wife called "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named")])]), _vm._v(". Not our Womenblood. Not our gut power. Onion Wife hurled "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named ")])]), _vm._v("upon the sons of the men who gouged White Crow, who split her and beat her, and broke her, and left her Dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named")])]), _vm._v(", Bia whispers, is a "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("of this Earth that even "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Wolf ")])]), _vm._v("cannot name, a "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("we cannot leash or tend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These men brought great and terrible to us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Onion Wife brought rage that trembles around us like wounded Enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia places her hand beneath my chin. Bawitčhuwa eyes you like Wolf eyes Hunter with fresh meat. I see her. Waiting. Wanting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named ")])]), _vm._v("rattles along Rivers beside her want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wind snips and flaps our robes. I tell you this, my Baide, to prepare you. You must watch for Tricksters of all kinds, my Baide. Do not trust easy ways. "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("must-not-be-named ")])]), _vm._v("dangles before us like good. Like easy. Like always Trickster. We are small beside Earth stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spiders spin sticky twine beside me, their silver thread catches light. Bia swipes my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Sleep is a Badger snuffling outside the skin of our Lodge. The Horses Blue Elk gave paw the ground close to my head . . Shudder . . Flinch . . Flap their tails. I smell blood bladders, roil of Horse piss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 50. ",
      "epub:type": "pagebreak",
      "id": "pg_50",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I see shadows of Women . . shadows of "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("bowel-Spirit Women. Shadows of Enemy Women")])]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hot shiver-snorts of Horses come at me like War Men. Horses paw, their stone-sharpened hooves too close to my skull.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("I am both awake and asleep. Moon spears through tule mats to find my feet Rabbit-twitching, my breath clibbing like a small Bird’s heart clibs in my hand before Death. I hear sounds "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Walking Trees ")])]), _vm._v("make as They move through Moon skin nights. When "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Walking Trees ")])]), _vm._v("uproot and walk, They sing in the shadowy forests, and we hear Birds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do all things lie?")]), _vm._v(" "), _c('p', {
    staticClass: "indent4"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ka"), _c('i', [_vm._v("-wit")]), _vm._v(" ka"), _c('i', [_vm._v("-wit")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent4"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("ka"), _c('i', [_vm._v("-wit")]), _vm._v(" ka"), _c('i', [_vm._v("-wit")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Horse piss yellow as Moon light leaks beneath my Buffalo robe, and wets me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I clean myself outside, alone, in the hour of whimpering Horses, in night-of-always-now, in the needle-sharp score of needle Trees walking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I listen. All night Bia’s words are hot as cooking rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sleep the sleep of stones. Deep. Dreaming. In night’s dark rattly breath, animals scritter around me. Monsters and Men who become Monsters. Stone Ogres coming out of "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("Th")]), _vm._v("eir stone caves to watch Women. Ogres who want only to save us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wake to bundles tied on the shorn manes of Blue Elk’s gifts. One Horse blinded. His tail stripped to bone, mane cut to blood. Someone wants Blue Elk cut from me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know what I am.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am the one Bawitčhuwa sends "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("bad Spirits, the Devil, must-not-be-named")])]), _vm._v(". Small snorts from her wound-Womb. All Around me.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec14",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec14"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 51. ",
      "epub:type": "pagebreak",
      "id": "pg_51",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("clean")]), _vm._v(" sing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atawatchi puffs smoke from his lungs, a Stream so thin it whistles the low whistle of snakes before striking. His smoke s-s-lips sl-its bush and shadow grasses-s. Bawitčhuwa’s smile drifts away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smoke rises from camp—blue claws of smoke rise to—call "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("White Weta")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smoke Smudge centers me. Becomes the center of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In blue smoke I am lit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In blue smoke I am lit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In bark smoke of Atawatchi’s prayers. I see Agai River gleam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe pulls me to edge of Atawatchi’s circle. There, he says. Can you see them, my Baide? Enemy all around?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see dense trunks of Trees close to Water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, he tells me. Look there. Closer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Little by little Enemy moves toward us, he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look where Appe points and scat-scattered darkness becomes Men crouched in fields, in grassy Deer beds, in hill cracks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I look again I see nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atawatchi shakes his head. It is beyond, far beyond us, he tells Appe. We cannot chase what-will-be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("bad Spirit ")])]), _vm._v("comes:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe will not go with other men to hunt. All day he haunts fields and tall grasses. Early day, he digs a hole for himself at camp edge. Early night, he rubs his skin with dirt. Appe’s eyes are crazy, moving the way Antelope hops, jumpy at noises no one hears. He knows what I fear. I fear change coming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All day, all night Appe watches nothing at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atawatchi prays for him now for he sees what we do not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atawatchi says we need a Ceremony for all the People.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flatbird listens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wait . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 52. ",
      "epub:type": "pagebreak",
      "id": "pg_52",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day will come, Appe tells me, when you will see differently. Days will no longer be alive to you. You will olden, my Baide. What remains is what you have learned, what you take with you from Here.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keep Here. Be Here. He knocks on my chest with his knuckles and my heart quickens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Know bad day will come, he said. Prepare.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec15",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec15"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 53. ",
      "epub:type": "pagebreak",
      "id": "pg_53",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Day of many days of want")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk left as Sun dulled Sky—"), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit Sky")])]), _vm._v("—in the hour of first feeding. Animals turn colors of dust. I am as colorless as Turtle shell, gristle, pocked bone, butchered mouths. I rise and collect myself the way tree seeds collect. I look toward Budding "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("S")]), _vm._v("eason when seeds become the breath of Trees after winter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Appe says, We know the length of our days before each day comes. In the waking hour")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we are fizzing breath, edge of animal sleep, and if we stay still we will hear ourselves return to our skins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Animals shiver in shiver grass of Blue Elk’s leaving. He has gone to scout for Enemy. He has gone to honor me. Blue Elk’s Horse knows ways of Mountain Goats and steps so no Enemies can hear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While other "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("H")]), _vm._v("unters sleep, Blue Elk reaches the cool dark of high rock overhangs. His "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("H")]), _vm._v("orse sidesteps the slittering snores of quiet "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("s")]), _vm._v("nakes. His shoulders wrapped in Weasel skins, his waist bare and sleek. His skin is the color of red stones. His nose is fine-boned as Deer Woman. He keeps his face close to Horse’s head as he rides toward coming winter quiet as blue "), _c('span', {
    staticClass: "ash"
  }, [_vm._v("s")]), _vm._v("nake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blue Elk, his wood-dark eyes, his guarding lashes, will have many wives. I will be first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This I know. No one holds another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sees Deer herd asleep in frost grass and hunts Men he cannot see. He cannot see the me I become. A soon-wife with many responsibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bia says my eyes wander too much. She says she can see my want for travel, to be as far away as Warriors who hunt Men. She is not wrong. I want to travel like Agai back to my birthplace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wind rushes down Mountains and blows our scent to animals. Deer, Antelope hide from us now. We have stayed so long we have "), _c('span', {
    attrs: {
      "aria-label": " Page 54. ",
      "epub:type": "pagebreak",
      "id": "pg_54",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("lost the ability to smell our own kill smell. Black flapping Birds carry our names to their Brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our time of gathering "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("here ")])]), _vm._v("is over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our time of dancing "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("here ")])]), _vm._v("is over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is the Season to pack, to carry, to take away.")]), _vm._v(" "), _c('div', {
    staticClass: "indent3"
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("Now is the end of Gathering . . We have done what must be done.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec16",
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "head2",
    attrs: {
      "id": "sec16"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 55. ",
      "epub:type": "pagebreak",
      "id": "pg_55",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("First day of man"), _c('span', {
    staticClass: "strike"
  }, [_vm._v("y")]), _vm._v(" bad days")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The last time I saw Appe alive, he was crouched near first fork of River. His eyes wild looking here, looking there, toward hills, toward River bank that flanked us. Appe startled again and again. He became Deer with kill hooves skittering for Life; he shoved me to hard ground. My legs burned in the crush of sting weed. A "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("bad Spirit ")])]), _vm._v("had found us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I became the Fish that tricks other Fish, stunned and flapping on the ground, calling out to River. I heard sounds of a thousand bees grinding the still air above me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bad day had come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far down Valleys white moths quivered above fields. I looked toward camp. Bia unmoving. Women and old Men stopped work to listen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earth rumbled. My legs began to tremble, then shake. Buffalo . . Not Buffalo . . Enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men rode toward us from all sides.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Women shrieked. Children cried. Dust plumed down Mountains scattering dirt clods. A Man I did not know pitched forward over the head of his Horse and his black mouth opened to dirt as red Horse clattered over him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then I was running. Black-tailed Deer quivered beside me bounding toward River. I ran beside Deer before Deer cut to hills. The lungs of a great animal gathered wind behind me. Hooves hacked Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I threw my hands up in gusts of Horse’s pass. My scalp hissed. Slick-face Enemy halted Enemy Horse. His sweat stench circled me. He laughed and fisted a thin tail of my hair over his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I scrambled up River cliffs where dirt gave way to roiling sand and fell into galloping Water. River churned bubbles as if a thousand silver Birds were flapping at my head, twirling me "), _c('span', {
    attrs: {
      "aria-label": " Page 56. ",
      "epub:type": "pagebreak",
      "id": "pg_56",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("end over end over end. Far below, giant rocks as greasy as Bear bones pulled River down to green, then black, and I was sinking sucked beneath dark bellies of boulders so huge families of "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirits ")])]), _vm._v("gathered beneath them. Ogres chuzzled my sinking body. Nickering.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Horse swam far above me, yellow Water foaming in the churn of His legs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was free.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Powder Moon drifts in Sky. My Bia’s huckleberry-stained hands comb my hair. For a Lightning strike I am among my People. Breath-less. And then I am leaving. My "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Spirit ")])]), _vm._v("whiffling. Tamarack smoke lifts me. Dark "), _c('i', [_c('span', {
    staticClass: "ash"
  }, [_vm._v("Wolf ")])]), _vm._v("stands on the hill, ready to call me away. Elders say"), _c('span', {
    staticClass: "ash"
  }, [_vm._v(", ")]), _vm._v("Death is "), _c('i', [_vm._v("to be taken")]), _vm._v(" from the place that homes us"), _c('span', {
    staticClass: "ash"
  }, [_vm._v(", ")]), _vm._v("and released into Stars.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Currents rushed me to low ground. Horse rattled wetness from its bones and in the Water sting of Horse’s shaking, in the slap-swish of Horse’s tail, I was alive. As Enemy reclaimed his Horse, he lost his breechclout. His buttocks clenched Horse’s sleek belly and Horse turned wild, spinning and bucking in shallow Water, hooves spitting rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Earth slowed as Enemy leapt toward me, Enemy’s cock a raised fist. He grabbed me with might force. My head cracked his chest again, again, again, my bones a raid of lights as he thumped thumped thumped against me. I bled a Woman bowl of ache. I called out to Blue Elk. But Blue Elk did not answer my call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Enemy finished, he threw me sideways on his Horse and then we were running. Ground swayed beneath us—up and then down. My stomach spilled; ground heaved. We stopped at the End of the World.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-r"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 57. ",
      "epub:type": "pagebreak",
      "id": "pg_57",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Strange Enemy Men gathered beside us. My blood calling them. My wound a gash.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Otter Woman was tied to the back of another Enemy Horse, her body limp, still as Deer meat. Her head bled a River down Horse’s side. I heard others crying. I tried to kick off Horse but was bound by Enemy fists. Enemy Rider slapped my buttocks. And all Enemy laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("I smelled Death. Last shudder of liver and teeth, bone stink of scalps. I named our Dead: Stands Down Thunder . . Stony Dog’s Hair . . Water Comes to Blood . . Flights Flint . . Smoked Lodge . . Smoked Lodge . . my Appe. I saw the long black whip of Smoked Lodge’s hair. I would have reached to touch my Appe, claim his scalp if I could. I snapped at Smoked Lodge with my teeth to catch one strand of Appe’s hair so he would travel with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was it I saw then? Sky stuttering with light? Trees overhead bending toward me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No. What I knew to be beautiful was ugly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My line of sight was Men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enemy Men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Men above and around me. Touching me. Clapping me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enemy Horse charged forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lumpy hills throbbed in my heart as Enemy hand covered my face.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747e2e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0